<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'configure-image.adjust-image'">_Ajustar tamaño de imágenes</span>
  </div>
  <!-- Contenedor -->
  @if (configureImage.editor) {
    <image-editor
      [selectedSize]="configureImage.selectedSize"
      [imageUrl]="configureImage.logo"
      (canvasSelect)="canvasSelect($event.canvas)"></image-editor>
  }@else {
    <div class="configure-image__body-container">
      <div class="configure-image__content">
        <p class="common-modal__content-header-info"
          [afTranslate]="'configure-image.automatic-redimension'"></p>
        <ul class="configure-image__form-container">
          @for (logo of configureImage.listLogos; track $index) {
            @if (!$first) {
              <li class="configure-image__container">
                <div>
                  <div class="common-text-input__block-header">
                    <label class="common-text-input__label">
                      <span class="common-text-input__text-label">
                        {{logo.to}} {{'configure-image.max-size' | afTranslate}} {{logo.size}}
                      </span>
                    </label>
                    <div class="common-text-input__buttons-right-header">
                      <button class="common-button__icon-sm-noborder"
                        (click)="showEditor(logo)">
                        <i class="lf-icon-edit common-icon__md"></i>
                      </button>
                    </div>
                  </div>
                  <span class="configure-image__subtitle">
                    {{logo.use}}
                  </span>
                </div>
                <div class="configure-image__image-container">
                  <img class="configure-image__image"
                    alt="Logo"
                    [src]="logo.logo">
                </div>
              </li>
            }
          }
        </ul>
      </div>
        <!-- Footer botonera -->
      <div class="common-modal__footer">
        <button class="common-button__text"
            (click)="handleAccept()">
            <span class="common-button__text-title"
            [afTranslate]="'configure-image.finish'">_Finalizar</span>
        </button>
      </div>
    </div>
  }
</div>
